import { Component, Output, EventEmitter, ElementRef } from '@angular/core';

import { scrollToElementVertically } from 'rev-shared/util/ElementPositionUtil';

import { MainHeaderPositionService } from 'rev-portal/navigation/mainHeader/MainHeaderPosition.Service';

@Component({
	selector: 'add-poll-button',
	template: `
		<button
			id="ewAddPoll"
			type="button"
			class="btn-icon-left"
			(click)="onAddPoll()"
			vbBtnPrimary>
			<span class="glyphicons plus"></span>
			{{ 'Event_AddPoll' | translate }}
		</button>
	`,
	standalone: false
})
export class AddPollButtonComponent {
	@Output() public addPoll: EventEmitter<any> = new EventEmitter();

	private readonly element: HTMLElement;

	constructor(
		elementRef: ElementRef,
		private readonly MainHeaderPosition: MainHeaderPositionService,
	){
		this.element = elementRef.nativeElement;
	}

	public onAddPoll(): void {
		this.addPoll.emit();

		scrollToElementVertically(this.element, this.MainHeaderPosition.height);
	}
}
